export default "__VITE_ASSET__YFnsHaGk__"